import BaseModelAPI from '../BaseModelAPI';

export default class GenderList extends BaseModelAPI {

	static entity = 'genderlist'
	static entityName = 'gender';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
